import { Component, Input, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { CaptureAuthorizedPaymentComponent } from './capture-authorized-payment/capture-authorized-payment.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rental-reservation-security-deposit-info',
  templateUrl: './rental-reservation-security-deposit-info.component.html',
  styleUrls: ['./rental-reservation-security-deposit-info.component.scss'],
})
export class RentalReservationSecurityDepositInfoComponent implements OnInit {
  @Input() partner;
  @Input() countryData;
  @Input() reservation;

  public busy: boolean = false;
  public securityDepositInfo: any = {};
  public securityDepositStatueses: any = [
    {
      status: 0,
      label: 'bikeshop.rentals.security_deposit_statuses.scheduled',
    },
    {
      status: 1,
      label: 'bikeshop.rentals.security_deposit_statuses.authorized',
    },
    { status: 2, label: 'bikeshop.rentals.security_deposit_statuses.captured' },
    { status: 10, label: 'bikeshop.rentals.security_deposit_statuses.expired' },
    {
      status: 11,
      label: 'bikeshop.rentals.security_deposit_statuses.authorization_failed',
    },
    {
      status: 12,
      label: 'bikeshop.rentals.security_deposit_statuses.capture_failed',
    },
    {
      status: 100,
      label: 'bikeshop.rentals.security_deposit_statuses.cancelled',
    },
  ];

  constructor(
    private rentalsService: RentalsService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.getRentalReservationSecutiryDepositInfo();
  }

  getRentalReservationSecutiryDepositInfo() {
    this.rentalsService
      .getRentalReservationSecurityDepositInfo(
        this.partner.ID,
        this.reservation.id,
      )
      .subscribe((securityDeposit) => {
        this.securityDepositInfo = securityDeposit;
      });
  }

  getStatus(statusID) {
    return this.securityDepositStatueses
      .filter((x) => {
        return x.status === statusID;
      })
      .pop().label;
  }

  authorizePayment() {
    this.busy = true;
    this.rentalsService
      .postSecurityDepositAuthorize(this.partner.ID, this.reservation.id)
      .subscribe(
        (securityDeposit) => {
          this.securityDepositInfo = securityDeposit;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  cancelAuthorization() {
    this.busy = true;
    this.rentalsService
      .postSecurityDepositCancel(this.partner.ID, this.reservation.id)
      .subscribe(
        (securityDeposit) => {
          this.securityDepositInfo = securityDeposit;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  releaseAuthorization() {
    this.busy = true;
    this.rentalsService
      .postSecurityDepositRelease(this.partner.ID, this.reservation.id)
      .subscribe(
        (securityDeposit) => {
          this.securityDepositInfo = securityDeposit;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  captureAuthorization() {
    const modalRef = this.modalService.open(CaptureAuthorizedPaymentComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.securityDepositInfo = this.securityDepositInfo;
    modalRef.componentInstance.partner = this.partner;
    modalRef.result.then((result) => {
      if (
        result.capturedAmount > 0 &&
        result.capturedAmount <= this.securityDepositInfo.authorizationAmount &&
        (this.securityDepositInfo.statusID === 1 ||
          this.securityDepositInfo.statusID === 12)
      ) {
        this.busy = true;
        this.rentalsService
          .postSecurityDepositCapture(
            this.partner.ID,
            this.reservation.id,
            result,
          )
          .subscribe(
            (securityDeposit) => {
              this.securityDepositInfo = securityDeposit;
              this.busy = false;
            },
            (err) => {
              this.busy = false;
            },
          );
      }
    });
  }
}
